module.exports = __webpack_public_path__ + "img/seo_tracker_no_search.6b65d80b.png";